module.exports = __webpack_public_path__ + "static/2021-07-02-13-02-54-579-fs8-fs8-4d5cb0e0c57a29d6d9a644eafc905e0e.png";